import script from "./lottery-combos-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./lottery-combos-picker.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__